import { useEffect, useState } from 'react';
import { useFetchCallback } from '@services/services';
import toast from 'react-hot-toast';
import { Announcement } from '@interfaces/general';

interface AnnouncementFilter {
  date: string;
  plan: string;
  page_size: number;
  is_active?: boolean;
}

export const useGetAnnouncement = (filter: AnnouncementFilter) => {
  const [announcement, setAnnouncement] = useState<Announcement | undefined>();

  const { isFetching, call } = useFetchCallback<
    undefined,
    {
      results: Announcement[];
    }
  >('get', '', 'v2');

  const fetchAnnouncement = async () => {
    if (filter.plan === 'desconocido') {
      return undefined;
    }
    try {
      const fullUrl = `announcements?date=${filter.date}&plan=${filter.plan}&is_active=${filter.is_active}&page_size=${filter.page_size}`;
      const response = await call({ path: fullUrl });
      if (response) {
        const [firstResult] = response.results;
        setAnnouncement(firstResult);
      }
    } catch {
      toast.error('Error al obtener los anuncios filtrados');
    }
  };

  useEffect(() => {
    fetchAnnouncement();
  }, [filter.date, filter.plan, filter.page_size]);

  return {
    announcement,
    isFetching,
    fetchAnnouncement,
  };
};
